var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.3057 26.5995L50.4873 26.279L50.3057 25.9586L39.2558 6.45866L39.0509 6.09696L38.6366 6.13134L13.9367 8.18099L13.6034 8.20865L13.4321 8.49599L3.0322 25.9463L2.83388 26.279L3.03221 26.6118L13.4321 44.062L13.6034 44.3494L13.9367 44.377L38.6366 46.4266L39.0509 46.461L39.2558 46.0993L50.3057 26.5995Z",
    fill: "#4B038D",
    stroke: "#4B038D",
    strokeWidth: 1.29999
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6768 45.7777L13.991 43.8288L3.5911 26.279L10.2671 15.0132C22.7472 21.9113 32.767 32.716 38.6768 45.7777Z",
    fill: "#4B038D"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7903 13.9291L38.6903 6.77911L35.4403 14.2541L41.9403 25.954L49.7402 26.279L41.9403 26.604L35.4403 38.3039L38.6903 45.7788L34.7903 38.9539L18.484 37.9783L13.9905 43.8289L17.3872 37.2804L11.7155 26.929L3.59056 26.279L11.7155 25.629L17.3872 15.2776L13.9905 8.7291L18.5405 14.9041L34.7903 13.9291ZM18.5405 15.879L12.6905 26.279L18.5405 36.6789L34.7903 37.6539L41.2903 26.279L34.7903 14.9041L18.5405 15.879Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7402 26.279L38.6903 6.77911L34.7903 14.6817L41.2903 26.279L49.7402 26.279Z",
    fill: "#FAD9F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6903 6.77911L13.9905 8.7291L18.5405 15.879L34.7903 14.6817L38.6903 6.77911Z",
    fill: "#F49DF4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6903 45.7788L49.7402 26.279L41.2903 26.279L34.7903 37.8763L38.6903 45.7788Z",
    fill: "#F49DF4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9905 43.8289L38.6903 45.7788L34.7903 37.8763L18.5405 36.6789L13.9905 43.8289Z",
    fill: "#D35BFA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59056 26.279L13.9905 43.8289L18.5405 36.6789L12.6905 26.279L3.59056 26.279Z",
    fill: "#A02CDD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9905 8.7291L3.59056 26.279L12.6905 26.279L18.5405 15.879L13.9905 8.7291Z",
    fill: "#BB55F1"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2903 26.279L34.7903 14.6817L18.5405 15.879L12.6905 26.279L18.5405 36.6789L34.7903 37.8763L41.2903 26.279Z",
    fill: "#E79CF7"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2005 25.5416L27.7611 19.8892C27.8525 19.7955 27.9611 19.7211 28.0808 19.6703C28.2006 19.6195 28.329 19.5933 28.4587 19.5933C28.5884 19.5933 28.7168 19.6195 28.8365 19.6703C28.9562 19.7211 29.0649 19.7955 29.1562 19.8892C29.3392 20.0767 29.4419 20.3302 29.4419 20.5945C29.4419 20.8588 29.3392 21.1124 29.1562 21.2998L24.2931 26.3019L29.1562 31.2539C29.3392 31.4414 29.4419 31.6949 29.4419 31.9592C29.4419 32.2235 29.3392 32.4771 29.1562 32.6645C29.0652 32.7591 28.9567 32.8343 28.837 32.8858C28.7172 32.9373 28.5887 32.9641 28.4587 32.9647C28.3287 32.9641 28.2001 32.9373 28.0804 32.8858C27.9606 32.8343 27.8521 32.7591 27.7611 32.6645L22.2005 27.0122C22.1007 26.9185 22.0212 26.8048 21.9667 26.6783C21.9123 26.5517 21.8842 26.415 21.8842 26.2769C21.8842 26.1387 21.9123 26.0021 21.9667 25.8755C22.0212 25.749 22.1007 25.6353 22.2005 25.5416Z",
    fill: "#4B038D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4419 20.7076V31.8504L27.5848 31.1075L23.4991 26.279L25.3562 23.679L29.4419 20.7076Z",
    fill: "#4B038D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left_arrow.9e6ec5192243365f187e08a9da24688e.svg";
export { ForwardRef as ReactComponent };